import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  collection,
  getCountFromServer,
  query,
  where,
} from "firebase/firestore";
import { db } from "../services/firebase";
import { useSeller } from "../contexts/SellerContext";
import "./CatalogueCard.css";

const CatalogueCard = () => {
  const navigate = useNavigate();
  const { seller } = useSeller();
  const sellerId = seller?.sellerId;

  const [counts, setCounts] = useState({
    pending: 0,
    approved: 0,
    rejected: 0,
    total: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchCounts = async () => {
      if (!sellerId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const productsRef = collection(db, "products");
        const qPending = query(
          productsRef,
          where("sellerId", "==", sellerId),
          where("status", "==", "pending"),
        );
        const qApproved = query(
          productsRef,
          where("sellerId", "==", sellerId),
          where("status", "==", "approved"),
        );
        const qRejected = query(
          productsRef,
          where("sellerId", "==", sellerId),
          where("status", "==", "rejected"),
        );

        const [pendingSnap, approvedSnap, rejectedSnap] = await Promise.all([
          getCountFromServer(qPending),
          getCountFromServer(qApproved),
          getCountFromServer(qRejected),
        ]);

        if (isMounted) {
          const pCount = pendingSnap.data().count;
          const aCount = approvedSnap.data().count;
          const rCount = rejectedSnap.data().count;

          setCounts({
            pending: pCount,
            approved: aCount,
            rejected: rCount,
            total: pCount + aCount + rCount,
          });
          setLoading(false);
        }
      } catch (error) {
        console.error("[CatalogueCard] Error fetching product counts:", error);
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchCounts();

    return () => {
      isMounted = false;
    };
  }, [sellerId]);

  return (
    <div
      className="service-card catalogue-card"
      onClick={() => navigate("/MyCatalogue")}
      style={{
        backgroundImage: `linear-gradient(90deg, #ea7317 0%, hsla(0, 0%, 100%, 0.25) 100%), url("/cataluge.png")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="service-overlay"></div>
      <div className="service-content">
        <div className="catalogue-card-header">
          <h3 className="service-title">My Catalogue</h3>
          {!loading && counts.total > 0 && (
            <span className="catalogue-total-badge">{counts.total} items</span>
          )}
        </div>
        <div className="catalogue-stats">
          <span className="catalogue-stat-badge pending">
            Pending QC {loading ? "..." : counts.pending}
          </span>
          <span className="catalogue-stat-badge approved">
            Approved {loading ? "..." : counts.approved}
          </span>
          <span className="catalogue-stat-badge rejected">
            Rejected {loading ? "..." : counts.rejected}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CatalogueCard;
